module.exports = __webpack_public_path__ + "img/downAppCode6.a384a9a6.png";